import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import AnimatedImage from './AnimatedImage';

const Mission = () => {
  const { ref: contentRef, inView: contentInView } = useScrollAnimation({ threshold: 0.2 });

  const missions = [
    {
      iconSrc: '/icons/rahma.svg',
      title: 'Rahma (Care)',
      description: 'Compassionate and empathic support for every individual journey.'
    },
    {
      iconSrc: '/icons/ihsan.svg',
      title: 'Ihsan (Excellence)',
      description: 'Striving for the highest quality in clinical and digital experience.'
    },
    {
      iconSrc: '/icons/amanah.svg',
      title: 'Amanah (Trust)',
      description: 'Integrity in handling data and delivering spiritual guidance.'
    }
  ];

  return (
    <section id="mission" className="mission-section">
      <Container>
        <Row className="align-items-center g-4">
          {/* Left Content */}
          <Col lg={6} xs={12}>
            <div 
              ref={contentRef}
              className={`mission-content animate-on-scroll fade-in-up ${contentInView ? 'visible' : ''}`}
            >
              <h2 className="mission-title">Our Mission</h2>
              <p className="mission-subtitle">
                Ensuring that the Muslim woman is not left behind at any stage of her life's wellness journey.
              </p>
              
              <div className="mission-items">
                {missions.map((mission, index) => (
                  <div key={index} className="mission-item">
                    <div className="mission-icon-wrapper">
                      <img 
                        src={mission.iconSrc} 
                        alt={mission.title}
                        className="mission-icon-img"
                        loading="lazy"
                      />
                    </div>
                    <div className="mission-text">
                      <h3 className="mission-item-title">{mission.title}</h3>
                      <p className="mission-item-description">{mission.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
          
          {/* Right Image - Desktop */}
          <Col lg={6} className="d-none d-lg-block">
            <div className="mission-image-wrapper">
              <AnimatedImage
                src="/images/desktop-img.svg"
                alt="Faith-centered wellness for Muslim women"
                className="mission-img"
              />
            </div>
          </Col>
          
          {/* Right Image - Mobile */}
          <Col xs={12} className="d-lg-none">
            <div className="mission-image-wrapper">
              <AnimatedImage
                src="/images/mobile-img.svg"
                alt="Faith-centered wellness for Muslim women"
                className="mission-img"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Mission;